// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__V0nJ9","optSubtitle":"input_optSubtitle__qmhZB","dateNoYear":"input_dateNoYear__ZsRXJ"};